<template>
  <div class="stats-icons" :class="{ 'width-auto': autoWidth }">
    <div>
      <IconClock class="icon-courses" />
      <div class="description">
        <span>{{ stats.rounded.videoDuration }}+</span>
        Hours of video
      </div>
    </div>
    <div>
      <IconMonitorPlay class="icon-exercises" />
      <div class="description">
        <span>{{ stats.rounded.exercises }}+</span>
        Exercises
      </div>
    </div>
    <div>
      <IconPeople class="icon-students" />
      <div class="description">
        <span>2M+</span>
        Students
      </div>
    </div>
  </div>
</template>

<script>
import IconClock from '../../assets/svg/icon-auto-clock.svg?vue-component';
import IconMonitorPlay from '../../assets/svg/icon-auto-monitor-play.svg?vue-components';
import IconPeople from '../../assets/svg/icon-auto-meet-the-team.svg?vue-components';

export default {
  components: { IconClock, IconMonitorPlay, IconPeople },
  props: {
    stats: { type: Object, default: () => ({}), required: true },
    autoWidth: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.stats-icons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 970px;
  height: 69px;
  margin: 58px auto 0 auto;

  > div {
    width: 202px;
    display: flex;
    flex-direction: row;

    .description {
      display: flex;
      flex-direction: column;
      align-self: center;
      font-weight: 500;
      color: var(--main-light);

      span {
        font-weight: 400;
        font-size: 40px;
      }
    }
  }

  svg {
    margin-right: 20px;

    path[stroke="#000C1F"] {
      stroke: var(--main-light);
    }

    path[stroke="#3DAFB8"] {
      stroke: var(--extreme-blue);
    }
  }

  &.width-auto {
    max-width: 100%;

    > div {
      width: auto;
    }
  }

  @include bp($bp-laptop) {
    > div .description span {
      font-size: 32px;
    }
  }

  @media screen and (max-width: 720px) {
    height: auto;
    justify-content: center;
    flex-direction: column;
    margin: var(--spacing-40) auto;
    padding: 0;

    &.width-auto > div {
      width: 204px;
    }

    > div {
      margin-left: auto;
      margin-right: auto;

      .description span {
        font-size: 32px;
      }

      &:not(:last-of-type) {
        margin-bottom: var(--spacing-44);
      }

      svg {
        height: 70px;
        width: 70px;
      }
    }
  }
}
</style>
